import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { isChangeLogsEnabled } from '../environments/environment';
import { ChangeLogsApiService } from './shared/services/change-logs-api.service';

export const waitlistGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const router = inject(Router);
  try {
    const allowed = sessionStorage.getItem('flow.wl.entry') === '1';
    if (allowed) {
      try { sessionStorage.removeItem('flow.wl.entry'); } catch {}
      return true;
    }
  } catch {}
  return router.parseUrl('/scheduler');
};

export const waitlistSuccessGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const router = inject(Router);
  try {
    const ok = sessionStorage.getItem('flow.wl.success') === '1';
    if (ok) {
      try { sessionStorage.removeItem('flow.wl.success'); } catch {}
      return true;
    }
  } catch {}
  return router.parseUrl('/scheduler');
};

export const changeLogsAvailableGuard: CanActivateFn = (_route, _state): boolean | UrlTree => {
  if (isChangeLogsEnabled()) return true;
  return inject(Router).createUrlTree(['/not-found']);
};

export const changeLogsAuthGuard: CanActivateFn = (_route, _state): boolean | UrlTree => {
  if (!isChangeLogsEnabled()) {
    return inject(Router).createUrlTree(['/not-found']);
  }
  const isLoggedIn = inject(ChangeLogsApiService).isLoggedIn;
  return isLoggedIn ? true : inject(Router).createUrlTree(['/change-logs/login']);
};


